var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"circles"},[_c('span',{staticClass:"one"}),_c('span',{staticClass:"two"}),_c('span',{staticClass:"three"})]),_c('div',{staticClass:"pacman"},[_c('span',{staticClass:"top"}),_c('span',{staticClass:"bottom"}),_c('span',{staticClass:"left"}),_c('div',{staticClass:"eye"})])])])
}]

export { render, staticRenderFns }